import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { editTenantWorkflow } from './editTenant';
import { addTenantWorkflow } from './addTenant';

export const workflows: WorkflowOptions[] = [
  editTenantWorkflow,
  addTenantWorkflow,
  ...Object.values(generateAssetStatusWorkflow('tenant')),
];
export default workflows;
